<!-- =========================================================================================
  File Name: UploadVideoSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h6>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPLOAD" }} VIDEO FOR {{dataName.toUpperCase()}}</h6>
      <!-- <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} SCHEDULE</h4> -->
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">

        <div class="slot-fields" v-for="(formData, index) in videos.data" :key="index">

          <div class="contained-example-container" :style="{ opacity: opacity}"  :id="'div-video-'+index" >
            <div  :id="'div-with-'+index" class="vs-con-loading__container" :ref="'div-with-'+index">
              <br>
              <div>
                <span style="font-weight: bold"> Video {{ index + 1 }}:</span>
                <!-- <span v-if="formData.video"
                      class="danger"
                      @click="inputRemove(index)"
                      style="color:red;float: right;cursor: pointer">Remove</span> -->
                      </div>
                  <br>
 
              <div class="img-container w-64 mx-auto flex items-center justify-center">

                <video  width="250" controls :src="video_cdn + formData.video" ></video>

              </div>
            </div>
          </div>
          <div class="modify-img flex justify-between mt-5">
            
            <!--            <input type="file" class="hidden" ref="updateImgInput" @change="uploadVideo" accept="video/*">-->
            <input type="file"  ref="fileupload" @change="uploadVideo(index,$event)" accept="video/*" >
            <!--            <vs-button class="mr-4" type="flat" > Video</vs-button>-->
          </div>
          <small style="color:red;" class="mt-1">Max Size: 20MB</small>
          <br>
          <label class="vs-select--label w-full">Date *</label>
          <vs-row class="mb-2">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
              <datepicker class="w-full" v-model="formData.date" format="MM/dd/yyyy" :minimumView="'day'"
                          :maximumView="'year'" :initialView="'month'"></datepicker>
            </vs-col>
          </vs-row>
          <label class="vs-select--label w-full">Time *</label>
           <vs-row class="mb-2">
            <vs-col class="ml-6 mr-6" vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
            <flat-pickr v-model="formData.start_time" :config="configdateTimePicker"  class="picker" name="start_time" placeholder="Start time"/>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
            <flat-pickr v-model="formData.end_time" :config="configdateTimePicker" class="picker" name="end_time" placeholder="End time"/>
            </vs-col>
            </vs-row>
          <label class="vs-select--label w-full">Camera</label>
          <v-select label="name" :closeOnSelect="true" v-model="formData.camera" :options="cameras"/>

        </div>
        <br>
        <!-- <div class="slot-actions pr-2 mt-1 ">
          <vs-button color="primary" size="small"
                     @click="inputAdd()">Add Another Video
          </vs-button>

        </div> -->

      </div>

    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {
  ALL_CAMERAS,
  ALL_LOCATIONS,
  GET_INCIDENT_VIDEOS_DETAILS,
  REQUEST_INCIDENT,
  UPDATE_INCIDENT_VIDEOS,
  UPLOAD_VIDEO,
  DELETE_INCIDENT_VIDEOS,
  ME_DATA,
  CAMERAS_BY_MANAGER_LOCATION,
  GET_CAMERA_BY_LOCATION
} from '@/graphql'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    moment
  },
  data() {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: "H:i",
        time_24hr: false,
        altInput: true,
        dateFormat: "H:i",
      },
      dataDate: '',
      start_time: '',
      end_time: '',
      dataLocation: [],
      dataCamera: [],
      locations: [],
      cameras: [],
      dataName: '',
      dataEmbeded: '',
      dataId: null,
      video_cdn:'',
      checkvideo:true,
      videos:
        {
        data: [
          {
        "incident_id": "",
        "camera": "",
        "video": "",
        "date": "",
        "start_time": "",
        "end_time": "",
          }
          ],
        },
       opacity:1,

    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id,name,location,incident_videos} = JSON.parse(JSON.stringify(this.data))
        this.getcamera(location.id)
        this.dataId = id
        this.dataName=name
        this.videos.data = [ {
        "incident_id": "",
        "camera": "",
        "video": "",
        "date": "",
        "start_time": "",
        "end_time": "",
          }]
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return this.checkvideo
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }

  },
  methods: {
    openLoadingInDiv(index){
      document.querySelector('#div-video-'+index).style.opacity = 0.2;
      this.$vs.loading({
        type:'sound',
        container: '#div-with-'+index,
        scale: 0.6
      })
    },
    inputAdd() {

      this.videos.data.push({
        "incident_id": "",
        "camera": "",
        "video": "",
        "date": "",
        "start_time": "",
        "end_time": "",

      });
      // console.log(this.videos.data)

    },
    inputRemove(index) {

      this.videos.data.splice(index, 1);
    },
    uploadVideo(index, input) {

      if (input.target.files && input.target.files[0]) {
        let limit = 1024 * 1024 * 20;
          if(input.target.files[0].size > limit){
            this.sizemessage()
            return false
          }
        this.checkImg = "somthing"
        const reader = new FileReader()
        reader.onload = e => {
          this.videos.data[index].video = e.target.result
          this.openLoadingInDiv(index);
          this.checkvideo=false
          this.$apollo
            .mutate({
              mutation: UPLOAD_VIDEO,
              variables: {
                video: this.videos.data[index].video,
                oldvideo: this.oldvideo,
              }
            })
            .then(response => {
              if (response) {
                this.oldvideo = ''
                if (response.data.uploadVideo.status == "SUCCESS") {
                  this.videos.data[index].video = response.data.uploadVideo.video_name
                  this.$vs.loading.close(`#div-with-${index} > .con-vs-loading`)
                  document.querySelector('#div-video-'+index).style.opacity = 1;

                  this.checkvideo=true
                }
              }
            }).catch(error => {
            console.log(error)
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            document.querySelector('#div-video-'+index).style.opacity = 1;
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    StatusSuccess() {
      this.$vs.notify({
        title: "Incident",
        text: 'Incident Update Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    submitData() {
      var camera = []
      var validKeys = [ 'id' ,'name' ];
      if(this.videos.data.length>0){
      for (var i = 0; i < this.videos.data.length; i++) {
        if(this.videos.data[i].video!='' && this.videos.data[i].date!='' && this.videos.data[i].start_time!='' && this.videos.data[i].end_time!='' && this.videos.data[i].camera!=''){
        delete this.videos.data[i].__typename
        delete this.videos.data[i].created_at
        delete this.videos.data[i].id
        Object.keys(this.videos.data[i].camera).forEach((key) => validKeys.includes(key) || delete this.videos.data[i].camera[key]);
        this.videos.data[i].camera = this.videos.data[i].camera
        this.videos.data[i].incident_id = this.dataId
        this.videos.data[i].date = moment(String(this.videos.data[i].date)).format('MM/DD/YYYY')
        }
        else{
          if(this.videos.data[i].video==''){
             this.failedmessage('Incident Video is Required')
             return
          }
          if(this.videos.data[i].date==''){
             this.failedmessage('Incident Date is Required')
              return
          }
          if(this.videos.data[i].start_time=='' || this.videos.data[i].end_time==''){
             this.failedmessage('Incident Times are Required')
              return
          }
          if(this.videos.data[i].camera==''){
             this.failedmessage('Incident Camera is Required')
             return
          }  
        }
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_INCIDENT_VIDEOS,
                variables: {
                  videos: this.videos.data
                }
              })
              .then(response => {
                if (response) {
                  this.StatusSuccess()
                  this.$refs.fileupload[0].value=null;
                  this.$emit('closeSidebar')
                  this.initValues()
                }
              }).catch(error => {
              console.log(error)
            })
          }
        }
      })
      }
      else{
        this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: DELETE_INCIDENT_VIDEOS,
                variables: {
                  id: this.dataId
                }
              })
              .then(response => {
                if (response) {
                  this.StatusSuccess()
                  this.$emit('closeSidebar')
                  this.initValues()

                }
              }).catch(error => {
              console.log(error)
            })
          }
        }
      })

      }
    },
    getIncidentVideosData(id) {
      this.$apollo
        .query({
          query: GET_INCIDENT_VIDEOS_DETAILS,
          variables: {
            id: id
          },
        })
        .then(response => {
          if (response.data.getIncidentDetails != null) {
            if (response.data.getIncidentDetails.status == 'SUCCESS') {
              for (var i = 0; i < response.data.getIncidentDetails.videos.length; i++) {
                var data = JSON.parse(response.data.getIncidentDetails.videos[i])
                this.videos.data.push(data)

              }

            }
          }


        })

    },
    failedmessage(note){
        this.$vs.notify({
        title: "Incident",
        text: note,
        color: 'danger',
        position: 'top-right'
      })
    },
     sizemessage(){
        this.$vs.notify({
        title: "Incident",
        text: 'Video is too Large!',
        color: 'danger',
        position: 'top-right'
      })
    },
    initValues() {
      this.dataName = ''
      this.dataDate = ''
      this.start_time = ''
      this.end_time = ''
      this.dataLocation = []
      this.dataCamera = []
      this.locations = []
      this.cameras = []
      this.videos.data = [
         {
        "incident_id": "",
        "camera": "",
        "video": "",
        "date": "",
        "start_time": "",
        "end_time": "",
          }
      ]
    },
   getcamera(location){
     this.$apollo
        .mutate({
          mutation: GET_CAMERA_BY_LOCATION,
          variables: {
            location_id:location
          }
        })
        .then(response => {
          if (response){
            this.cameras=response.data.location_cameras

          }
        }) .catch(error => {
        console.log(error)
      });
   }   
  //  conditionMethod(role,id){
  //    if(role=="manager"){
  //     this.$apollo
  //     .mutate({
  //       mutation: CAMERAS_BY_MANAGER_LOCATION,
  //       variables: {
  //       id:id
  //    },
  //     })
  //     .then(response => {
  //       var cameras=[]
  //        for (let i = 0; i < response.data.user.locations.length; i++) {
  //           for (let j = 0; j < response.data.user.locations[i].cameras.length; j++) {
  //                 cameras.push(response.data.user.locations[i].cameras[j])
  //           }
  //         }
  //         this.cameras=cameras
  //     }).catch(error => {
  //         console.log(error)
  //     });

  //     }
    // if(role=="admin"){
    // this.$apollo
    //   .mutate({
    //     mutation: ALL_CAMERAS,
    //   })
    //   .then(response => {
    //     this.cameras = response.data.cameras
    //   })
    // // }
    // }    
  },
  created() {
    this.video_cdn=process.env.VUE_APP_VIDEOS_CDN_LINK
    //  this.$apollo
    //   .mutate({
    //     mutation: ME_DATA,
    //   })
    //   .then(response => {
    //     this.conditionMethod(response.data.me.roles[0].name,response.data.me.id)
    //   }).catch(error => {
    //       console.log(error)
    //   }); 
      
    // this.$apollo
    //   .mutate({
    //     mutation: ALL_CAMERAS,
    //   })
    //   .then(response => {
    //     this.cameras = response.data.cameras
    //   })

  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }

}

.picker {
  width: 175px;
}
</style>
